import { createApp } from 'vue'
import Eshop from '../components/Eshop.vue'

createApp(Eshop).mount('#eshop')
